
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProjectCard from '@/components/projects/ProjectCardNew.vue';
import { Project, User } from '@/generated/graphql';
import CardsContainer from '@/components/card/CardsContainerNew.vue';
import ElementsSizeProvider from '@/components/uiSize/ElementsSizeProvider.vue';

@Component({
	components: {
		ElementsSizeProvider,
		CardsContainer,
		ProjectCard,
	},
})
export default class ProjectCollection extends Vue {
	@Prop({ type: Array, required: true }) readonly projects!: Project[];
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: String, required: true }) readonly companyId!: string;
	@Prop({ type: Boolean, default: false }) readonly hideManager!: boolean;

	get completedProjects(): Project[] {
		// Filter the projects with completed set to true
		return this.projects.filter((project) => project.completed);
	}
}
